$(function () {
  console.log("DataLayer is loaded");

  if ($("body").hasClass("template-index")) {
    //console.log('Home page');
    getProducts("home");
  }

  if ($("body").hasClass("template-collection")) {
    //console.log('Collection page');
    getProducts("categoria");
  }

  if ($("body").hasClass("template-product")) {
    //console.log('Product page');
    getProductSingle();
  }

  if ($("body").hasClass("template-cart")) {
    //console.log('Cart page');
    reportRemoveFromCart();
    addAttributesToCart();
  }

  if ($("body").hasClass("template-search")) {
    //console.log('Search page');
    getProducts("resultado-busqueda");
  }
});

function sendDataToDataLayer(data) {
  //console.log('Sending data to DataLayer');
  dataLayer.push(data);
  //console.log(data);
}

function getProducts(listname) {
  console.log("Getting products");
  var products = [];

  $("[data-product-handle]").each(function () {
    var handle = $(this).data("product-handle");

    let count = 0;

    $.getJSON("/products/" + handle + ".js", function (product) {
      count++;
      let productData = {
        id: product.variants[0].sku ? product.variants[0].sku : product.id,
        name: product.title,
        price: product.price ? Math.trunc(product.price / 100).toString() : "",
        brand: product.vendor,
        category: product.tags[0],
        variant: product.variants[0].title,
        list: listname,
        position: count,
      };
      products.push(productData);
    });
  });

  let data = {
    event: "productImpression",
    ecommerce: {
      currencyCode: "COP",
      impressions: products,
    },
  };

  sendDataToDataLayer(data);

  //subscribe to click add-to-cart button class
  $(".add-to-cart").click(function () {
    //get parent grid__item and find data-product-handle attribute child
    var handle = $(this)
      .closest(".grid__item")
      .find("[data-product-handle]")
      .data("product-handle");
    console.log(handle);
    reportAddToCart(handle);
  });
}

function reportAddToCart(handle) {
  $.getJSON("/products/" + handle + ".js", function (product) {
    let productData = {
      id: product.variants[0].sku ? product.variants[0].sku : product.id,
      name: product.title,
      price: product.price ? Math.trunc(product.price / 100).toString() : "",
      brand: product.vendor,
      category: product.tags[0],
      variant: product.variants[0].title,
    };

    let data = {
      event: "addToCart",
      ecommerce: {
        currencyCode: "COP",
        add: {
          products: [productData],
        },
      },
    };

    sendDataToDataLayer(data);
  });
}

function getProductSingle() {
  let prevUrl = document.referrer;
  var homeUrl = window.location.host;

  //get element with data-product-handle attribute
  var handle = $("[data-product-handle]").data("product-handle");

  if (handle != undefined) {
    var procedenciaName = "";

    if (prevUrl.indexOf(homeUrl) !== -1) {
      if (prevUrl.indexOf("search?") !== -1) {
        procedenciaName = "resultado-busqueda";
      } else if (prevUrl.indexOf("/collections/") !== -1) {
        // procedenciaName = "categoria";
        let index = prevUrl.indexOf("collections");
        procedenciaName = prevUrl.substring(index + "collections".length + 1);
      } else {
        procedenciaName = "home";
      }
    }

    $.getJSON("/products/" + handle + ".js", function (product) {
      let productData = {
        id: product.variants[0].sku ? product.variants[0].sku : product.id,
        name: product.title,
        price: product.price ? Math.trunc(product.price / 100).toString() : "",
        brand: product.vendor,
        category: product.tags[0],
        variant: product.variants[0].title,
        list: "product",
        position: 1,
      };

      let data = {
        event: "productDetail",
        ecommerce: {
          currencyCode: "COP",
          detail: {
            products: [productData],
            actionField: { list: procedenciaName },
          },
        },
      };

      sendDataToDataLayer(data);
    });

    //subscribe to click addtocart_js button class
    $(".addtocart_js").click(function () {
      reportAddToCart(handle);
    });
  }
}

function reportRemoveFromCart() {
  //subscribe to click cart_remove button class
  $(".cart_remove").click(function () {
    let handle = $(this).data("product-handle");
    let quantity = $(this).data("product-quantity");

    $.getJSON("/products/" + handle + ".js", function (product) {
      let productData = {
        id: product.variants[0].sku ? product.variants[0].sku : product.id,
        name: product.title,
        price: product.price ? Math.trunc(product.price / 100).toString() : "",
        brand: product.vendor,
        category: product.tags[0],
        variant: product.variants[0].title,
        quantity: quantity,
      };

      let data = {
        event: "removeFromCart",
        ecommerce: {
          currencyCode: "COP",
          remove: {
            products: [productData],
          },
        },
      };

      sendDataToDataLayer(data);
    });
  });
}
function addAttributesToCart() {
  var sessionID = "";
  // try {
  //   if (document.cookie.indexOf("_ga=") > -1) {
  //     ga_Cookie = document.cookie.split("_ga_261CHE6WS3")[1].split(".");
  //     sessionID = ga_Cookie[2];
  //   }
  // } catch (e) {
  //   console.log("Error al obtener la cookie de GA");
  // }
  try {
    const ga4CookieName = "_ga_261CHE6WS3";
    if (document.cookie.indexOf(ga4CookieName) > -1) {
      const ga4Cookie = document.cookie
        .split(ga4CookieName)[1]
        .split(";")[0]; // en caso de múltiples cookies

      // Buscar el valor entre 's' y el siguiente '$'
      const sessionIdMatch = ga4Cookie.match(/s(\d+)\$/);
      if (sessionIdMatch && sessionIdMatch[1]) {
        const sessionIDTemp = sessionIdMatch[1];
        sessionID = sessionIDTemp;
      } else {
        console.log("No se encontró el Session ID en la cookie.");
      }
    }
  } catch (e) {
    console.log("Error al obtener la cookie de GA4:", e);
  }

  $("#session_id").val(sessionID);
  $("#timestamp_micros").val(Date.now());
}
